const isCsUser = userId => {
  const csUsernameRegex = /@chama/;

  return !!(userId && csUsernameRegex.test(userId));
};

export default isCsUser;



// WEBPACK FOOTER //
// ../utils/functions/is-cs-user.js